module.exports = __webpack_public_path__ + "static/media/Apache-Maven.0f207880.svg";